export var MarketplaceIds;
(function (MarketplaceIds) {
    MarketplaceIds["US"] = "US";
    MarketplaceIds["CA"] = "CA";
    MarketplaceIds["ES"] = "ES";
    MarketplaceIds["FR"] = "FR";
    MarketplaceIds["IT"] = "IT";
    MarketplaceIds["DE"] = "DE";
    MarketplaceIds["UK"] = "UK";
})(MarketplaceIds || (MarketplaceIds = {}));
export const MarketplaceToTopLevelDomain = {
    [MarketplaceIds.CA]: '.ca',
    [MarketplaceIds.US]: '.com',
    [MarketplaceIds.ES]: '.es',
    [MarketplaceIds.FR]: '.fr',
    [MarketplaceIds.IT]: '.it',
    [MarketplaceIds.DE]: '.de',
    [MarketplaceIds.UK]: '.co.uk',
};
/**
 * Returns the marketplace ID based on the search params or domain.
 * Priority: searchParams > domain-based detection > 'US' fallback
 */
export const getMarketplace = (searchParams) => {
    const marketplaceId = searchParams.get('marketplaceId');
    // Use tld detection if marketplaceId is invalid
    if (marketplaceId && marketplaceId in MarketplaceIds)
        return marketplaceId;
    const hostname = window.location.hostname;
    const entry = Object.entries(MarketplaceToTopLevelDomain).find(([_m, t]) => hostname.endsWith(t));
    return entry ? entry[0] : MarketplaceIds.US;
};
